"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _flowRight = _interopRequireDefault(require("lodash/flowRight"));
var _SubMenuWithItemsDefault = _interopRequireDefault(require("./SubMenuWithItemsDefault.render"));
var _menuItems = require("../../../../../constants/menuItems");
var _getShowHomepageToggle = _interopRequireDefault(require("../../../../../utils/getShowHomepageToggle"));
var _withAppConfig = _interopRequireDefault(require("../../../../HOCs/withAppConfig"));
var _withHeaderApi = _interopRequireDefault(require("../../../../HOCs/withHeaderApi"));
var _withUserAndPreferences = _interopRequireDefault(require("../../../../HOCs/withUserAndPreferences"));
var _Functionality = _interopRequireDefault(require("../../NavItem/Functionality"));
var _SubMenu = require("../SubMenu.style");
var _utils = require("../utils");
// @ts-ignore
const SubMenuWithItems = _ref => {
  let {
    menuItems,
    testId,
    showing,
    positionToLeft,
    walkMeId,
    onNavItemSelected,
    onNavItemDeselected,
    children,
    data,
    openChangePasswordModal
  } = _ref;
  const showHomepageToggle = (0, _getShowHomepageToggle.default)(data);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, menuItems.map((_ref2, index) => {
    let {
      text,
      icon,
      customRender,
      code,
      metadata,
      type
    } = _ref2;
    if (customRender === _menuItems.CUSTOM_DROPDOWN_NEW_HOME_TOGGLE && !showHomepageToggle) return null;
    return /*#__PURE__*/_react.default.createElement(_SubMenu.SubMenuItem, {
      id: "".concat(testId, "-").concat((0, _utils.getNavItemNameFromIntlText)(text)),
      key: text,
      "data-test-id": "".concat(testId, "-").concat((0, _utils.getNavItemNameFromIntlText)(text)),
      noHover: customRender
      // @ts-ignore
      ,
      showing: showing,
      positionToLeft: positionToLeft,
      isFirst: index === 0,
      isLast: index === menuItems.length - 1,
      noRoundedCorners: true,
      "data-walkmeid": "".concat(walkMeId, "-").concat((0, _utils.getNavItemNameFromIntlText)(text))
    }, /*#__PURE__*/_react.default.createElement(_Functionality.default
    // @ts-ignore
    , Object.assign({}, menuItems[index], {
      // @ts-ignore
      onFocus: onNavItemSelected,
      onBlur: onNavItemDeselected,
      openChangePasswordModal: openChangePasswordModal
    }), children && children({
      text,
      icon,
      showing,
      code,
      metadata,
      type
    }), !children && /*#__PURE__*/_react.default.createElement(_SubMenuWithItemsDefault.default, {
      text: text,
      showing: showing,
      customRender: customRender
    })));
  }));
};
var _default = exports.default = (0, _flowRight.default)(_withAppConfig.default, _withHeaderApi.default, _withUserAndPreferences.default)(SubMenuWithItems);